import { Location } from '@angular/common';
import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { filter, firstValueFrom, Subscription } from 'rxjs';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { FormatsEnums } from 'src/app/enum/formats-enums';
import { InventoryOutputStateEnums } from 'src/app/enum/inventory-output-state-enums';
import { InventoryOutputTypeEnums } from 'src/app/enum/inventory-output-type-enums';
import { WindowEnums } from 'src/app/enum/window-enums';
import { OptionWindowModel } from 'src/app/models/authentication/option-window.model';
import { UserModel } from 'src/app/models/authentication/user.model';
import { FormatModel } from 'src/app/models/formats/format.model';
import { InventoryOutputModel } from 'src/app/models/inventory/inventory-output.model';
import { BranchModel } from 'src/app/models/management/branch.model';
import { SubrentalOutputPrintModel } from 'src/app/models/print/subrental/subrental-output-print.model';
import { OptionWindowService } from 'src/app/services/authentication/option-window.service';
import { WindowService } from 'src/app/services/authentication/window.service';
import { FormatService } from 'src/app/services/formats/format.service';
import { DateConverterService } from 'src/app/services/global-services/date-converter.service';
import { FormControlStateService } from 'src/app/services/global-services/form-control-state.service';
import { UserAuthenticatedService } from 'src/app/services/global-services/user-authenticated.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { InventoryService } from 'src/app/services/inventory/inventory.service';
import { BranchService } from 'src/app/services/management/branch.service';
import { SubrentalOutputService } from 'src/app/services/subrental/subrental-output.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-register-subrental-output',
  templateUrl: './register-subrental-output.component.html',
  styleUrls: ['./register-subrental-output.component.scss'],
  standalone: false
})
export class RegisterSubrentalOutputComponent implements OnInit, OnDestroy {
  branchId: number = 0;
  companyId: number = 0;
  disabledActions: boolean = true;
  disabledDetail: boolean = true;
  disabledForm: boolean = false;
  disabledState: boolean = false;
  finishLoadingPrint: boolean = false;
  formSubrentalOutput: FormGroup = new FormGroup({});
  formatModel: FormatModel = new FormatModel();
  iconState: string = "pi pi-lock-open";
  inventorySubrentalId: number = 0;

  isOpened: string | undefined = undefined;
  listBranches: any[] = [];
  listSubrentalOutputType: any[] = [];
  listObservers: Array<Subscription> = new Array<Subscription>();
  mainBranchByUser: BranchModel = new BranchModel();
  nameWindow: string = 'Captura Salidas de Subalquiler';
  permissionUpdatable: boolean = false;
  permissionsUser: OptionWindowModel[] = [];
  projectName = ProjectName.projectName;
  quantityDetails: number = 0;
  severityState: string = "danger";
  stateOpen: number = InventoryOutputStateEnums.open;
  stateText: string = 'Abierta';
  subrentalOutputContract: InventoryOutputModel = new InventoryOutputModel();
  subrentalOutputPrintModel: SubrentalOutputPrintModel = new SubrentalOutputPrintModel();
  subrentalOutputId: number = 0;
  subrentalOutputTypeId: number = InventoryOutputTypeEnums.output;
  titleState: string = "";
  url: string = "subrental-output";
  userAuthenticated: UserModel = new UserModel();
  visibleDevolution: boolean = false;
  visibleState: boolean = false;

  constructor(private activatedRoute: ActivatedRoute,
    private branchService: BranchService,
    private dateConverterService: DateConverterService,
    private formBuilder: FormBuilder,
    private formatService: FormatService,
    private formControlStateService: FormControlStateService,
    private headerService: HeaderService,
    private inventoryService: InventoryService,
    private location: Location,
    private optionWindowService: OptionWindowService,
    private router: Router,
    private subrentalOutputService: SubrentalOutputService,
    private title: Title,
    private toastHandlerService: ToastHandlerService,
    private userAuthenticatedService: UserAuthenticatedService,
    private windowService: WindowService) { }

  async ngOnInit(): Promise<void> {
    this.headerService.setTitle(this.nameWindow);
    await this.validateForm(new InventoryOutputModel());
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    await this.getPermission();
    this.activatedRoute.params.subscribe(params => {
      this.subrentalOutputId = Object.keys(params).length > 0 ? params?.id : null;
    });
    this.handleInitialState();
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  async ngOnDestroy() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      const window = windowsOpened.findIndex(x => x === this.url);
      if (window != -1) {
        windowsOpened.splice(window, 1);
        localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      }
    }

    this.listObservers.forEach(sub => sub.unsubscribe());
  }

  async changeConsecutive() {
    const branchId = this.formSubrentalOutput.get("branchId")?.value;
    const inventoryOutputTypeId = this.formSubrentalOutput.get("inventoryOutputTypeId")?.value;
    let consecutive = this.formSubrentalOutput.get("consecutive")?.value;

    if (this.subrentalOutputContract.consecutive == consecutive) return;

    if (branchId == null || branchId == 0) {
      this.toastHandlerService.showToast('warning', 'Seleccione una sucursal.', 'Atención');
      return;
    }

    if (inventoryOutputTypeId == null || inventoryOutputTypeId == 0) {
      this.toastHandlerService.showToast('warning', 'Seleccione un tipo subalquiler.', 'Atención');
      return;
    }

    consecutive = consecutive === 0 ? null : consecutive;
    if (consecutive == null) {
      await this.resetSubrentalOutput(branchId);
      return;
    }

    try {
      this.subrentalOutputContract = await firstValueFrom(this.subrentalOutputService.getSubrentalOutputByKeysAsync(branchId, inventoryOutputTypeId, consecutive));
      this.subrentalOutputId = this.subrentalOutputContract.inventoryOutputId;
      await this.validateForm(this.subrentalOutputContract);
      this.location.replaceState(`/subrental-output/register/${this.subrentalOutputId}`);
    } catch (error) {
      console.error('Error al buscar la salida de subalquiler por campos de recuperación.', error);
      await this.validateForm(this.subrentalOutputContract);
    }
  }

  changeInventoryOutputType() {
    const branchId = this.formSubrentalOutput.get("branchId")?.value;
    const inventoryOutputTypeId = this.formSubrentalOutput.get("inventoryOutputTypeId")?.value;

    this.inventorySubrentalId = 0;
    const modelSubrentalOutput = new InventoryOutputModel();
    modelSubrentalOutput.branchId = branchId;
    modelSubrentalOutput.inventoryOutputTypeId = inventoryOutputTypeId;
    this.subrentalOutputContract = modelSubrentalOutput;
    this.validateForm(modelSubrentalOutput);
  }

  async changeBranch(branchId: number, loadAllLists: boolean) {
    this.branchId = branchId;
    if (loadAllLists) {
      await this.getAllLists();
    } else {
      this.resetSubrentalOutput(branchId);
    }
  }

  async changeState() {
    if (this.subrentalOutputContract.inventoryOutputTypeId == InventoryOutputTypeEnums.replacement) {
      this.toastHandlerService.showToast('warning', 'No es posible abrir una salida tipo "Reposición".', 'Atención');
      return;
    }
    if (!this.validations()) return;
    try {
      this.subrentalOutputContract = await firstValueFrom(this.subrentalOutputService.setSubrentalOutputState(this.subrentalOutputContract.inventoryOutputId));
      await this.validateForm(this.subrentalOutputContract);
      this.toastHandlerService.showToast('success', 'El estado de la salida de subalquiler se modificó exitosamente.');
    } catch (error) {
      console.error('Error al cambiar el estado de la salida de subalquiler.', error);
    }
  }

  async createNewSubrentalOutput() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast('warning', 'El usuario no tiene permisos para crear salida de subalquiler. Comuníquese con el administrador del sistema.', 'Atención');
      return;
    }

    const inventoryOutputTypeId = this.subrentalOutputContract.inventoryOutputTypeId || InventoryOutputTypeEnums.output;
    this.subrentalOutputId = 0;
    this.subrentalOutputContract = new InventoryOutputModel();
    this.subrentalOutputContract.branchId = this.branchId;
    this.subrentalOutputContract.inventoryOutputTypeId = inventoryOutputTypeId ?? InventoryOutputTypeEnums.output;
    await this.validateForm(this.subrentalOutputContract);
    this.quantityDetails = 0;
    this.disabledDetail, this.disabledActions = true;
    this.location.replaceState(`/subrental-output/register`);
  }

  async deleteSubrentalOutput() {
    if (!this.validations()) return;

    if (this.subrentalOutputContract.inventoryOutputStateId != InventoryOutputStateEnums.open) {
      this.toastHandlerService.showToast('warning', 'No es posible eliminar, la salida de subalquiler no está abierta.', 'Atención');
      return;
    }

    if (this.quantityDetails != 0) {
      this.toastHandlerService.showToast('warning', 'No es posible eliminar, la salida de subalquiler tiene artículos relacionados.', 'Atención');
      return;
    }

    const result = await Swal.fire({
      title: 'Atención',
      text: `¿Realmente desea eliminar la salida de subalquiler ${this.subrentalOutputContract.consecutive}?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si',
      cancelButtonText: 'No'
    });
    if (result.isConfirmed) {
      try {
        await firstValueFrom(this.subrentalOutputService.deleteSubrentalOutput(this.subrentalOutputContract.inventoryOutputId));
        this.toastHandlerService.showToast('success', 'La salida de subalquiler fue eliminada exitosamente.', '');
        this.createNewSubrentalOutput();
      } catch (error) {
        console.error('Error al eliminar la salida de subalquiler.', error);
      }
    }
  }

  disabledButtons() {
    this.disabledDetail = true;
  }

  finishLoading(finish: boolean) {
    this.finishLoadingPrint = finish;
  }

  async getAllLists(...listsToLoad: Array<'branches' | 'outputType'>) {
    try {
      const lists = {
        branches: async () => {
          this.listBranches = await firstValueFrom(this.branchService.getAllBranchesForSelectAsync());
        },
        outputType: async () => {
          this.listSubrentalOutputType = await firstValueFrom(this.subrentalOutputService.getAllSubrentalOutputTypeForSelect());
        }
      };
      if (listsToLoad.length) {
        await Promise.all(listsToLoad.map(list => lists[list]()));
      } else {
        await Promise.all([
          lists.branches(),
          lists.outputType()
        ]);
      }
    } catch (error) {
      console.error('Error obtener las listas.', error);
    }
  }

  getButtonClick(buttonClick: any) {
    let consecutive = this.formSubrentalOutput.get("consecutive")?.value;
    const branchId = this.formSubrentalOutput.get("branchId")?.value;
    const inventoryOutputTypeId = this.formSubrentalOutput.get("inventoryOutputTypeId")?.value;

    if (branchId == null || branchId == 0) {
      this.toastHandlerService.showToast('warning', 'Seleccione una sucursal.');
      return;
    }

    if (inventoryOutputTypeId == null || inventoryOutputTypeId == 0) {
      this.toastHandlerService.showToast('warning', 'Seleccione un tipo subalquiler.', 'Atención');
      return;
    }

    consecutive = consecutive === 0 ? null : consecutive;
    this.handleSubrentalOutputNavigation(buttonClick, branchId, inventoryOutputTypeId, consecutive);
  }

  async getFirstBranchByUserAuthenticatedAsync() {
    try {
      const response = await firstValueFrom(this.branchService.getFirstBranchByUserAuthenticatedAsync());
      this.branchId = response.branchId;
      this.companyId = response.companyId;
      await this.getAllLists();
    } catch (error) {
      console.error('Error al obtener la sucursal del usuario.', error);
    }
  }

  async getFormatByCompanyAndCode() {
    try {
      if (this.formatModel.formatId === 0) {
        this.formatModel = await firstValueFrom(
          this.formatService.getFormatByCompanyAndCode(this.companyId!, FormatsEnums.subrentalOutput)
        );
      }
    } catch (error) {
      console.error('Error al obtener el formato:', error);
    }
  }

  async getInventorySubrental() {
    const response = await firstValueFrom(this.inventoryService.getInventorySubrental());
    if (response) {
      this.inventorySubrentalId = response.inventoryId
    }
  }

  async getPermission() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find(x => x === this.url);
      windowsOpened.push(this.url);
      localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      if (this.isOpened) {
        this.toastHandlerService.showToast('warning', `No se permite tener dos ventanas/pestañas de ${this.nameWindow} abiertas.`);
      }
    } else {
      localStorage.clear();
    }
    await this.getInventorySubrental();

    try {
      this.permissionUpdatable = await firstValueFrom(this.windowService.getPermissionProfileByUrl(this.url));
      await this.getPermissionsForUserByWindow();
    } catch (error) {
      console.error('Error al buscar los permisos del perfil.', error);
    }
  }

  async getPermissionsForUserByWindow() {
    this.userAuthenticated = await firstValueFrom(
      this.userAuthenticatedService.userObservable.pipe(
        filter(user => user && user.userId !== 0)
      )
    );
    this.companyId = this.userAuthenticated.companyId;
    this.permissionsUser = await firstValueFrom(this.optionWindowService.getPermissionsForUserByWindow(WindowEnums.SubrentalOutput));
  }

  async getSubrentalOutputById() {
    try {
      this.subrentalOutputContract = await firstValueFrom(this.subrentalOutputService.getSubrentalOutputById(this.subrentalOutputId));
      this.subrentalOutputId = this.subrentalOutputContract.inventoryOutputId;
      await this.changeBranch(this.subrentalOutputContract.branchId, true);
      await this.validateForm(this.subrentalOutputContract);
    } catch (error) {
      console.error('Error al buscar la salida de subalquiler.', error);
    }
  }

  goToBack(event: Event) {
    event.preventDefault();
    this.router.navigate(['/subrental-output']);
  }

  goToHome(event: Event) {
    event.preventDefault();
    this.router.navigate(['/main']);
  }

  async handleInitialState() {
    if (this.subrentalOutputId !== null && this.subrentalOutputId !== 0) {
      await this.getSubrentalOutputById();
    } else {
      await this.getFirstBranchByUserAuthenticatedAsync();
      this.createNewSubrentalOutput();
    }
  }

  private async handleSubrentalOutputNavigation(buttonClick: any, branchId: number, inventoryOutputTypeId: number, consecutive: number | null) {
    const actionMap: Record<string, () => Promise<InventoryOutputModel>> = {
      first: () => firstValueFrom(this.subrentalOutputService.getFirstSubrentalOutputByKeysAsync(branchId, inventoryOutputTypeId)),
      previus: () => firstValueFrom(this.subrentalOutputService.getPreviusSubrentalOutputByKeysAsync(branchId, inventoryOutputTypeId, consecutive)),
      next: () => firstValueFrom(this.subrentalOutputService.getNextSubrentalOutputByKeysAsync(branchId, inventoryOutputTypeId, consecutive)),
      last: () => firstValueFrom(this.subrentalOutputService.getLastSubrentalOutputByKeysAsync(branchId, inventoryOutputTypeId))
    };

    const action = actionMap[buttonClick.target.id];
    if (!action) {
      await this.resetSubrentalOutput(branchId);
      return;
    }

    try {
      const subrentalOutput = await action();
      this.subrentalOutputContract = subrentalOutput;
      this.subrentalOutputId = subrentalOutput.inventoryOutputId;
      await this.validateForm(subrentalOutput);
      this.location.replaceState(`/subrental-output/register/${this.subrentalOutputId}`);
    } catch (error) {
      console.error(`Error al buscar la salida de subalquiler (${buttonClick.target.id}).`, error);
    }
  }

  async printPage() {
    if (!this.validations()) return;

    if (this.quantityDetails == 0) {
      this.toastHandlerService.showToast('warning', `No es posible imprimir la salida de subalquiler, no tiene ningún detalle.`);
      return;
    }

    if (this.subrentalOutputContract.inventoryOutputStateId === InventoryOutputStateEnums.open) {
      this.toastHandlerService.showToast('warning', `No es posible imprimir, la salida de subalquiler se encuentra en estado abierto.`);
      return;
    }

    this.toastHandlerService.clearAllToasts();
    await this.getFormatByCompanyAndCode();
    await this.getPrintSubrentalOutputs();
    this.finishLoadingPrint = false;
    await this.waitForComponenteImpresionToLoad();
  }

  async getPrintSubrentalOutputs() {
    this.subrentalOutputPrintModel = await firstValueFrom(this.subrentalOutputService.getSubrentalOutputByKeysByPrint(0, 0, this.subrentalOutputContract.inventoryOutputId));
  }

  async resetSubrentalOutput(branchId: number) {
    const inventoryOutputTypeId = this.subrentalOutputContract.inventoryOutputTypeId || InventoryOutputTypeEnums.output;
    this.subrentalOutputId = 0;
    this.subrentalOutputContract = new InventoryOutputModel();
    this.subrentalOutputContract.branchId = branchId;
    this.subrentalOutputContract.inventoryId = this.inventorySubrentalId;
    this.subrentalOutputContract.inventoryOutputTypeId = inventoryOutputTypeId;
    await this.validateForm(this.subrentalOutputContract);
    this.location.replaceState(`/${this.url}/register`);
  }

  async send(): Promise<any> {
    if (this.disabledForm) {
      this.toastHandlerService.showToast('warning', `No es posible guardar, la salida de subalquiler NO se encuentra en estado abierto.`);
      return;
    }

    if (this.formSubrentalOutput.valid) {
      const modelsubrentalOutput = this.formSubrentalOutput.getRawValue();

      //Hago null, los campos que permiten ser nulos:
      modelsubrentalOutput.deliveryDocument = modelsubrentalOutput.deliveryDocument || null;
      modelsubrentalOutput.observation = modelsubrentalOutput.observation || null;

      if (this.subrentalOutputId == 0) {
        modelsubrentalOutput.inventoryId = this.inventorySubrentalId;
        try {
          const response = await firstValueFrom(this.subrentalOutputService.createSubrentalOutput(modelsubrentalOutput));
          this.toastHandlerService.showToast('success', `La salida de subalquiler fue creada exitosamente.`);
          this.subrentalOutputContract = response;
          this.subrentalOutputId = this.subrentalOutputContract.inventoryOutputId;
          await this.validateForm(this.subrentalOutputContract);
          this.location.replaceState(`/subrental-output/register/${this.subrentalOutputId}`);
        } catch (error) {
          console.error('Error al crear la salida de subalquiler.', error);
        }
      } else {
        this.subrentalOutputContract.dateOutput = modelsubrentalOutput.dateOutput;
        this.subrentalOutputContract.deliveryDocument = modelsubrentalOutput.deliveryDocument;
        this.subrentalOutputContract.observation = modelsubrentalOutput.observation;
        try {
          const response = await firstValueFrom(this.subrentalOutputService.updateSubrentalOutput(this.subrentalOutputContract));
          this.toastHandlerService.showToast('success', `La salida de subalquiler fue modificada exitosamente.`);
          this.subrentalOutputContract = response;
          await this.validateForm(this.subrentalOutputContract);
        } catch (error) {
          console.error('Error al actualizar la salida de subalquiler.', error);
        }
      }
    } else {
      this.showValidationMessages();
    }
  }

  showValidationMessages(): void {
    const controlMessages: Record<string, Record<string, string>> = {
      branchId: {
        required: 'El campo sucursal es obligatorio.'
      },
      inventoryOutputTypeId: {
        required: 'El campo tipo salida es obligatorio.'
      },
      dateOutput: {
        required: 'El campo fecha de la salida es obligatorio.'
      },
      deliveryDocument: {
        maxlength: 'El campo permite máximo 15 carateres'
      },
      observation: {
        maxlength: 'El campo permite máximo 250 caracteres'
      },
    };
    Object.keys(controlMessages).forEach(controlName => {
      const control = this.formSubrentalOutput.get(controlName);
      if (control && control.invalid && control.errors) {
        const errors = control.errors;
        Object.keys(errors).forEach(errorKey => {
          const message = controlMessages[controlName][errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message, 'Atención');
          }
        });
      }
    });
  }

  async updateFormState() {
    const stateConfig: any = {
      [InventoryOutputStateEnums.open]: {
        severity: 'danger',
        icon: 'pi pi-lock-open',
        title: 'Cerrar',
        text: 'Abierta',
        isDisabled: false,
        enableConsecutive: this.subrentalOutputId !== 0,
      },
      [InventoryOutputStateEnums.close]: {
        severity: 'success',
        icon: 'pi pi-lock',
        title: 'Abrir',
        text: 'Cerrada',
        isDisabled: true,
        enableConsecutive: true,
      },
    };

    const currentState = this.subrentalOutputContract.inventoryOutputStateId;
    const config = stateConfig[currentState];
    const isReplacement = this.subrentalOutputContract.inventoryOutputTypeId === InventoryOutputTypeEnums.replacement;

    if (config) {
      this.severityState = config.severity;
      this.iconState = config.icon;
      this.titleState = config.title;
      this.stateText = config.text;
      this.disabledForm = isReplacement ? true : config.isDisabled;
      this.disabledActions = isReplacement ? true : config.isDisabled;
      this.disabledDetail = isReplacement ? true : config.isDisabled;
      const enableConsecutive = isReplacement ? true : config.enableConsecutive;
      this.disabledForm ? this.formSubrentalOutput.disable() : this.formSubrentalOutput.enable();
      const control = this.formSubrentalOutput.controls["consecutive"];
      enableConsecutive ? control.enable() : control.disable();
      this.formControlStateService.setControlState(this.formSubrentalOutput, ['devolution'], false);
    }
    if (!this.permissionUpdatable) setTimeout(() => this.formSubrentalOutput.disable());
    this.formControlStateService.setControlState(this.formSubrentalOutput, ['branchId', 'inventoryOutputTypeId'], true);

  }

  validations() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast('warning', 'El usuario no tiene permisos para modificar la salida subalquiler. Comuníquese con el administrador del sistema', 'Atención');
      return false;
    }

    if (this.subrentalOutputContract.inventoryOutputId == 0) {
      this.toastHandlerService.showToast('warning', 'Debe crear el encabezado de la salida de subalquiler.', 'Atención');
      return false;
    }
    return true;
  }

  async validateForm(subrentalOutput: InventoryOutputModel) {
    this.formSubrentalOutput = this.formBuilder.group({
      branchId: [subrentalOutput.branchId, [Validators.required, Validators.min(1)]],
      inventoryOutputTypeId: [subrentalOutput.inventoryOutputTypeId, [Validators.required, Validators.min(1)]],
      consecutive: [subrentalOutput.consecutive, []],
      dateOutput: [subrentalOutput.dateOutput ?
        this.dateConverterService.convertUtcToLocalDate(subrentalOutput.dateOutput) : null, [Validators.required]],
      deliveryDocument: [subrentalOutput.deliveryDocument, [Validators.maxLength(15)]],
      devolution: [null, []],
      observation: [subrentalOutput.observation, [Validators.maxLength(250)]]
    });
    this.updateFormState();
    this.visibleDevolution = subrentalOutput.inventoryOutputTypeId === InventoryOutputTypeEnums.replacement;

    if (this.visibleDevolution && subrentalOutput.inventoryOutputId != 0 && subrentalOutput.devolutionId) {
      const devolution = await firstValueFrom(this.subrentalOutputService.getDevolutionForSubrentalOutput(subrentalOutput.devolutionId));
      this.formSubrentalOutput.controls["devolution"].patchValue(devolution);
    }
  }

  waitForComponenteImpresionToLoad(): Promise<void> {
    return new Promise<void>((resolve) => {
      const check = async () => {
        if (this.finishLoadingPrint) {
          print();

          resolve();
        } else {
          setTimeout(check, 100);
        }
      };
      check();
    });
  }

}
